import React from 'react';
import { Box, Chip } from '@mui/material';

import { SettingDisplay } from 'lib/SettingDisplay';
import { IPointOfSaleSettingsProps } from 'components/settings/PointOfSaleSettings';
import { SettingDisplayText } from 'components/settings/SettingDisplayText';
import { SettingDisplayPassword } from 'components/settings/SettingDisplayPassword';
import { menuOrderTypeLabels, QikserveOrderType } from './QikserveSettingsEdit';

export const QikserveSettingsDisplay: React.FC<IPointOfSaleSettingsProps> = ({ settings, locationId }) => (
    <>
        {/* Common Only */}
        {locationId === undefined && (
            <>
                <SettingDisplayText title="Host" text={settings?.qikserveConnect?.host} />
                <SettingDisplayPassword title="API Key " text={settings?.qikserveConnect?.apiKey} />
                <SettingDisplayText title="Client ID" text={settings?.qikserveConnect?.clientId} />
                <SettingDisplayPassword
                    title="Client Secret"
                    text={settings?.qikserveConnect?.clientSecret}
                />
                <SettingDisplayText title="Market Name" text={settings?.qikserveConnect?.marketName} />
                <SettingDisplayText title="Locale" text={settings?.qikserveConnect?.locale} />
                <SettingDisplay label="Menu Order Types">
                    <Box display="flex" flexWrap="wrap" gap={1}>
                        {settings?.qikserveConnect?.menuOrderTypes?.map((type: QikserveOrderType) => (
                            <Chip color="primary" key={type} label={menuOrderTypeLabels[type]} />
                        ))}
                    </Box>
                </SettingDisplay>
            </>
        )}
        {/* Location Only */}
        {locationId !== undefined && (
            <SettingDisplayText title="Store Number" text={settings?.qikserveConnect?.storeNumber} />
        )}
    </>
);
